module.exports = __webpack_public_path__ + "mrstaticmedia/3-2@2x.92f6d2f5.png";